import { encodeUnicodeBase64 } from "utils";

export const mail = (submission = {}) =>
  `
Invitation à soumissionner

Construction Lavigne & Baril vous invite à fournir un prix, dans votre discipline (spécialité).

Les informations se retrouvent à l'URL suivant :
https://www.prosekur.ca/#/invitation/${encodeUnicodeBase64(
    JSON.stringify({
      id: submission?.id,
      title: submission?.title,
      client_name: submission?.client?.name,
      date_depot: submission?.date_depot,
      region: submission?.region?.label,
      user_name: submission?.user?.name + " " + submission?.user?.surname,
      user_mail: submission?.user?.mail,
    }),
  )}
`;
